/**
 * Chọn/chụp 1 ảnh (TT 83 C1-c). Trên điện thoại `capture` mở thẳng camera (trước cho
 * selfie, sau cho giấy tờ); trên máy tính là hộp chọn file. Xem trước ảnh đã chọn.
 */
import { useEffect, useRef, useState } from "react";
import { Button, Space, Typography } from "antd";
import { CameraOutlined } from "@ant-design/icons";

import { downscaleImage } from "@/features/identity/downscale";

const { Text } = Typography;

export function ImageCapture({
  label,
  hint,
  facing,
  value,
  onChange,
  testId,
}: {
  label: string;
  hint?: string;
  facing: "user" | "environment";
  value: File | null;
  onChange: (file: File | null) => void;
  testId: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (!value || typeof URL.createObjectURL !== "function") {
      setPreview(null);
      return;
    }
    const url = URL.createObjectURL(value);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [value]);

  return (
    <Space direction="vertical" size={4} style={{ width: "100%" }}>
      <Text strong>{label}</Text>
      {hint && <Text type="secondary">{hint}</Text>}
      {preview && (
        <img
          src={preview}
          alt={label}
          style={{ maxWidth: 240, maxHeight: 180, borderRadius: 8, objectFit: "cover" }}
        />
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        capture={facing}
        style={{ display: "none" }}
        data-testid={testId}
        onChange={async (e) => {
          const file = e.target.files?.[0];
          e.target.value = "";
          onChange(file ? await downscaleImage(file) : null);
        }}
      />
      <Button icon={<CameraOutlined />} onClick={() => inputRef.current?.click()}>
        {value ? "Chụp/chọn lại" : "Chụp hoặc chọn ảnh"}
      </Button>
    </Space>
  );
}
